/* ══════════════════════════════════════════════════════════════════
   产品卡运行时 —— 色点、卡内选项、付费配件、快速加购、对比托盘。

   规矩：
     · 不建 IntersectionObserver / rAF，要用就走 EB.motion
     · 不自己管浮层，加购完成后走 EB.overlay.open('cart-drawer')
     · **不算折扣金额**。加购只负责把该加的一次性提交，
       钱由 Shopify 的自动折扣 / Function 算，前台算出来的价对不上结账页就是灾难
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var COMPARE_KEY = 'eb:compare';
  var doc = document;

  function money(cents) {
    return (window.EB && window.EB.money) ? window.EB.money(cents) : (cents / 100).toFixed(2);
  }
  /* 文案全部来自 locale（theme.liquid 输出成 EBStrings），JS 里不写英文兜底以外的字。
     {{ count }} 这类占位符在这里替换，复数形式由 locale 的 one/other 决定。 */
  function t(key, fallback, vars) {
    var strings = window.EBStrings || {};
    var raw = strings[key];
    if (raw && typeof raw === 'object') raw = (vars && vars.count === 1) ? raw.one : raw.other;
    raw = raw || fallback;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        raw = raw.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), vars[k]);
      });
    }
    return raw;
  }
  function pressed(el, on) { el.setAttribute('aria-pressed', on ? 'true' : 'false'); }

  /* 加购按钮里除了文字还有一个图标（cart-add）。改文案要写进这个 span，
     直接写按钮的 textContent 会把 <svg> 一起冲掉 —— 图标在第一次加购之后
     就再也不回来了。没有 span 的旧标记（或别处复用的按钮）退回按钮本身。 */
  function labelNode(btn) { return btn.querySelector('[data-quickadd-label]') || btn; }

  /* ── 1. 色点：换图、换价、换卡片链接上的 ?variant= ─────────────── */
  function onSwatch(btn) {
    var card = btn.closest('[data-product-card]');
    if (!card) return;
    var group = btn.closest('[data-swatches]');

    group.querySelectorAll('[data-swatch]').forEach(function (s) { pressed(s, false); });
    pressed(btn, true);

    var img = card.querySelector('[data-card-image]');
    if (img && btn.dataset.variantImage) {
      img.src = btn.dataset.variantImage;
      img.removeAttribute('srcset');
    }

    var now = card.querySelector('.eb-price__now');
    if (now && btn.dataset.variantPrice) {
      now.lastChild.nodeValue = ' ' + btn.dataset.variantPrice;
    }
    var was = card.querySelector('.eb-price__was');
    if (was) {
      if (btn.dataset.variantCompare) { was.hidden = false; was.lastChild.nodeValue = ' ' + btn.dataset.variantCompare; }
      else { was.hidden = true; }
    }

    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.classList.contains('eb-btn') || a.closest('.eb-pcard__title')) {
        if (btn.dataset.variantUrl) a.href = btn.dataset.variantUrl;
      }
    });

    var idInput = card.querySelector('[data-quickadd-id]');
    if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;

    var addBtn = card.querySelector('[data-quickadd-btn]');
    if (addBtn) addBtn.disabled = btn.dataset.variantAvailable === 'false';
  }

  /* ── 2. 卡内选项（搭配卡）：只管选中态，变体解析交给用它的 section ── */
  function onOption(btn) {
    var row = btn.closest('[data-option-row]');
    row.querySelectorAll('.eb-opt').forEach(function (o) { pressed(o, false); });
    pressed(btn, true);
    if (window.EB && EB.emit) {
      EB.emit('card:option', {
        card: btn.closest('[data-product-card]'),
        position: row.dataset.optionPosition,
        value: btn.dataset.optionValue
      });
    }
  }

  /* ── 3. 付费配件：勾了就把合计写在加购按钮上 ─────────────────── */
  function onAddon(btn) {
    pressed(btn, btn.getAttribute('aria-pressed') !== 'true');
    var card = btn.closest('[data-product-card]');
    var on = card.querySelectorAll('[data-addon][aria-pressed="true"]');
    var extra = 0;
    on.forEach(function (a) { extra += parseInt(a.dataset.addonPrice, 10) || 0; });

    var addBtn = card.querySelector('[data-quickadd-btn]');
    if (addBtn) {
      var addLab = labelNode(addBtn);
      if (!addBtn.dataset.label) addBtn.dataset.label = addLab.textContent.trim();
      addLab.textContent = extra ? addBtn.dataset.label + ' · +' + money(extra) : addBtn.dataset.label;
    }
    var note = card.querySelector('[data-addon-note]');
    if (note) {
      note.hidden = on.length === 0;
      note.textContent = t('addons_note', 'Bike + {{ count }} accessories added together', { count: on.length });
    }
  }

  /* ── 4. 快速加购 ──────────────────────────────────────────────
     整车和勾上的配件一次提交。任何一件失败就整体不提交 ——
     半个 bundle 进购物车比加不进去更难解释。
     没有 JS 时表单原样 POST /cart/add，车照样加得进去。 */
  function onQuickAdd(e) {
    var form = e.target;
    if (!form.matches('[data-quick-add]')) return;
    if (!window.fetch) return;
    e.preventDefault();

    var card = form.closest('[data-product-card]') || form.closest('.eb-pcard');
    var btn = form.querySelector('button[type="submit"]');
    var id = form.querySelector('[name="id"]');
    if (!id) return;

    var items = [{ id: parseInt(id.value, 10), quantity: 1 }];
    /* 只有一份赠品的车：赠品跟车一起进购物车，和产品页一样带 _gift 标记。
       data-gift-id 只在赠品有货时才印（见 product-card 里「赠品和快捷加购」）；
       多份赠品的车卡上根本没有加购表单，按钮是去产品页选。 */
    var giftId = card && parseInt(card.dataset.giftId, 10);
    if (giftId) items.push({ id: giftId, quantity: 1, properties: { _gift: 'true' } });
    if (card) {
      card.querySelectorAll('[data-addon][aria-pressed="true"]').forEach(function (a) {
        var aid = parseInt(a.dataset.addonId, 10);
        if (aid) items.push({ id: aid, quantity: 1 });
      });
    }

    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description);
        if (window.EB) {
          EB.emit('cart:updated', { source: 'card', items: items });
          if (EB.overlay) EB.overlay.open('cart-drawer');
        }
        if (btn) {
          var lab = labelNode(btn);
          var label = btn.dataset.label || lab.textContent.trim();
          btn.dataset.label = label;
          lab.textContent = t('added', 'Added');
          /* 扫一次光。**加入购物车是这张卡上唯一真的发生过的事** ——
             一个只换了两个字的按钮，人不一定看得见自己成功了。
             reduced-motion 下这一句什么都不做。 */
          if (window.EB && window.EB.sheen) window.EB.sheen(btn);
          window.setTimeout(function () { lab.textContent = label; }, 1600);
        }
      })
      .catch(function () {
        form.submit(); /* 接口出问题就退回整页提交，别把人卡在原地 */
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  }

  /* ── 5. 对比托盘 ──────────────────────────────────────────────
     最多 4 台：对比表排不下第五列，横向滚动的对比表没人看。
     少于 2 台时按钮不可用，但托盘照样在 —— 它得告诉你还差什么。 */
  var tray = null;
  var trayMax = 3;   /* 兜底值；真正的上限写在托盘的 data-max 上 */

  function readCompare() {
    try { return JSON.parse(window.localStorage.getItem(COMPARE_KEY)) || []; }
    catch (err) { return []; }
  }
  function writeCompare(list) {
    try { window.localStorage.setItem(COMPARE_KEY, JSON.stringify(list)); } catch (err) { /* 隐私模式，忽略 */ }
  }

  function onCompare(btn) {
    var list = readCompare();
    var id = btn.dataset.compareId;
    var i = list.findIndex(function (x) { return String(x.id) === String(id); });

    if (i > -1) list.splice(i, 1);
    else {
      if (list.length >= trayMax) { flashFull(); return; }
      list.push({
        id: id,
        title: btn.dataset.compareTitle,
        url: btn.dataset.compareUrl,
        image: btn.dataset.compareImage
      });
    }
    writeCompare(list);
    renderTray();
  }

  function removeCompare(id) {
    writeCompare(readCompare().filter(function (x) { return String(x.id) !== String(id); }));
    renderTray();
  }
  function clearCompare() { writeCompare([]); renderTray(); }

  function flashFull() {
    if (!tray) return;
    tray.classList.add('is-full');
    window.setTimeout(function () { tray.classList.remove('is-full'); }, 1200);
  }

  function renderTray() {
    var list = readCompare();

    doc.querySelectorAll('[data-compare]').forEach(function (btn) {
      pressed(btn, list.some(function (x) { return String(x.id) === String(btn.dataset.compareId); }));
    });

    if (!tray) return;
    tray.hidden = list.length === 0;
    if (!list.length) return;

    var inner = tray.querySelector('[data-compare-inner]');
    var ready = list.length >= 2;
    var slots = list.map(function (x) {
      return '<span class="eb-cslot" title="' + escapeHtml(x.title) + '">' +
        (x.image ? '<img src="' + x.image + '" alt="" loading="lazy">' : '') +
        '<button type="button" class="eb-cslot__x" data-compare-remove="' + x.id + '" ' +
        'aria-label="' + escapeHtml(t('remove', 'Remove from compare')) + '">' + ICON_X + '</button></span>';
    }).join('');

    for (var i = list.length; i < trayMax; i++) slots += '<span class="eb-cslot eb-cslot--empty"></span>';

    inner.innerHTML =
      '<span class="eb-ctray__slots">' + slots + '</span>' +
      '<span class="eb-ctray__txt"><b>' +
      escapeHtml(t('selected', '{{ count }} / {{ max }} selected', { count: list.length, max: trayMax })) + '</b>' +
      '<span>' + escapeHtml(ready ? t('ready', 'Ready to compare') : t('need_more', 'Add one more bike to compare')) + '</span></span>' +
      '<span class="eb-ctray__acts">' +
      '<button type="button" class="eb-ctray__clear" data-compare-clear>' + escapeHtml(t('clear', 'Clear')) + '</button>' +
      '<a class="eb-btn eb-btn--forest eb-btn--compact" href="' + (tray.dataset.url || '#') + '"' +
      (ready ? '' : ' aria-disabled="true" tabindex="-1"') + '>' +
      escapeHtml(t('action', 'Compare ({{ count }})', { count: list.length })) + '</a></span>';
  }

  var ICON_X = '<svg viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="currentColor" ' +
    'stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── 6. 事件委托：一个监听器管全站所有卡片 ───────────────────── */
  doc.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest(
      '[data-swatch],[data-option-value],[data-addon],[data-compare],[data-compare-remove],[data-compare-clear]'
    );
    if (!el) return;

    if (el.hasAttribute('data-swatch')) {
      if (el.dataset.variantAvailable === 'false' && el.dataset.unavailable) return;
      e.preventDefault(); e.stopPropagation(); onSwatch(el);
    } else if (el.hasAttribute('data-option-value')) {
      e.preventDefault(); e.stopPropagation(); onOption(el);
    } else if (el.hasAttribute('data-addon')) {
      e.preventDefault(); e.stopPropagation(); onAddon(el);
    } else if (el.hasAttribute('data-compare')) {
      e.preventDefault(); e.stopPropagation(); onCompare(el);
    } else if (el.hasAttribute('data-compare-remove')) {
      e.preventDefault(); removeCompare(el.dataset.compareRemove);
    } else if (el.hasAttribute('data-compare-clear')) {
      e.preventDefault(); clearCompare();
    }
  });

  doc.addEventListener('submit', onQuickAdd);

  function mount() {
    tray = doc.querySelector('[data-compare-tray]');
    if (tray) trayMax = parseInt(tray.dataset.max, 10) || 4;
    renderTray();
  }

  /* 对比托盘的公开口子：产品页的「跟哪台比」下拉要往里加车。
     托盘的存取只有这一份实现，别在别处再写一遍 localStorage。 */
  if (window.EB) {
    window.EB.compare = {
      list: readCompare,
      add: function (item) {
        if (!item || !item.id) return;
        var list = readCompare();
        if (list.some(function (x) { return String(x.id) === String(item.id); })) return;
        if (list.length >= trayMax) { flashFull(); return; }
        list.push({ id: item.id, title: item.title, url: item.url, image: item.image });
        writeCompare(list);
        renderTray();
      },
      remove: removeCompare,
      clear: clearCompare
    };
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount);
  else mount();
  doc.addEventListener('shopify:section:load', renderTray);
})();
